import { createContext } from 'react'

import { TemplatesContextValue } from './TemplatesContext.types'

export const TemplatesContext = createContext<TemplatesContextValue | undefined>(undefined)
